<template>
  <div class="container">
    <el-card shadow="never">
    <h2>商户账号信息
      <ViewAccount
        v-show="(isEdit || readOnly) && !isMerchant"
        @success="handleViewAccount"
        :merchantId="merchantId"
        :isReset="false"
        :showViewBtn="ifHide"
      />
    </h2>
    <el-divider/>
    <el-form-item label="退回原因" prop="fNopassReason" class="red" v-if="(isEdit || readOnly) && form.fNopassReason">
      <el-input v-model="form.fNopassReason" style="width: 50%" disabled></el-input>
    </el-form-item>
    <el-form-item label="登录账号" prop="username" :error="userNameItemError">
      <el-input
        class="form-input"
        :disabled="isEdit || readOnly"
        v-model="form.username"
        placeholder="建议使用手机号，支持8~20位数字/字母"
        prop="username"
        @blur="checkUserName"></el-input>
      <span class="check-username-loading-view" v-show="checkLoading">
        <i class="el-icon-loading"></i>
        <span>检测中...</span>
      </span>
    </el-form-item>
    <el-form-item label="登录密码" prop="password" v-if="!readOnly && !isEdit">
      <el-input class="form-input" v-model="form.password" placeholder="8-20位字符，需包含大写字母，小写字母和数字" :disabled="readOnly"></el-input>
    </el-form-item>
    <el-form-item label="注册手机" prop="mobile" class="mobile">
      <el-input class="form-input" :disabled="readOnly" v-model="form.mobile" placeholder="11位正确手机号，用户登录账号密码找回"></el-input>
      <ChangePhone
        v-if="(isEdit || readOnly) && !isMerchant"
        :merchantId="merchantId"
        :fAgentId="fAgentId.toString()"
        @updateInit="getNewMobile"
        @change="(newPhone)=>{form.mobile = newPhone}"
      />
    </el-form-item>
    </el-card>
    <el-card shadow="never">
    <h2>商户基础信息</h2>
    <el-divider/>
    <el-form-item label="店铺类型" required>
      <el-select
        v-if="!isChain"
        style="width:120px;"
        :disabled="isEdit || readOnly"
        filterable
        placeholder="店铺类型"
        v-model="form.shopType"
        @change="changeShopType">
        <el-option label="总店" :value="1" ></el-option>
        <el-option label="分店" :value="0" ></el-option>
      </el-select>
      <div v-else>连锁总部</div>
    </el-form-item>
    <el-form-item
      label="总店商户编号"
      v-show="headShopMerchantIdInput"
      :rules="{ required: headShopMerchantIdInput, message: '请输入总店编号', trigger: 'blur' }"
      :error="headShopMerchantIdError">
      <el-input class="form-input" :disabled="readOnly || isUpgrade" v-model="form.headMerchantId" placeholder="总店商户编号" @blur="handleHeadShopMerchantIdBlur"></el-input>
    </el-form-item>
    <el-form-item label="商户信息" prop="businessInfoFlag" v-show="headShopMerchantIdInput && !isEdit && !readOnly" :required="headShopMerchantIdInput && !isEdit && !readOnly">
      <el-select filterable v-model="form.businessInfoFlag" @change="changeBusinessInfo" :disabled="readOnly">
        <el-option label="与总店一致" :value="1" ></el-option>
        <el-option label="与总店不一致" :value="0" ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="商户类型" prop="merchantAppSource" v-if="!isChain">
      <el-select v-model="form.merchantAppSource">
        <el-option :value="0" label="扫码点单"></el-option>
        <el-option :value="1" label="码上餐厅"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="商户性质" prop="realMerchantType">
      <el-select v-model="form.realMerchantType" @change="wxMchTypeChange" :disabled="(passed || businessEditable || readOnly) && !isUpgrade">
        <el-option :value="1" label="小微商户" v-if="!isUpgrade"></el-option>
        <el-option :value="2" label="个体商户"></el-option>
        <el-option :value="3" label="企业商户"></el-option>
        <el-option :value="4" label="事业单位"></el-option>
        <el-option :value="5" label="其他组织"></el-option>
      </el-select>
      <span @click.prevent="setUpgrade" v-if="canUpgrade" style="padding-left: 12px;">
        <el-radio v-model="isUpgrade" :label="true">升级</el-radio>
      </span>
    </el-form-item>

    <el-form-item label="是否连锁总部" prop="chainType" v-if="!isChain">
      <el-radio :disabled="isEdit" v-model="form.chainType" :label="0">否</el-radio>
      <el-radio :disabled="isEdit" v-model="form.chainType" :label="1">是</el-radio>
    </el-form-item>
    <el-form-item label="商户简称" prop="merchantShortName">
      <el-input class="form-input" v-model="form.merchantShortName" placeholder="商户简称，2~30个字，不能为纯数字，不能包含敏感词汇" :disabled="readOnly"></el-input>
    </el-form-item>
    <el-form-item label="行业类型" required>
      <el-row type="flex">
        <el-form-item
          prop="mccType"
          class="form-flex-item"
          :rules="{
            required: !businessEditable,
            message: '请选择全部行业',
            trigger: 'blur'
          }">
          <el-select
            style="width:200px;"
            :disabled="(passed || businessEditable || readOnly) && !isUpgrade"
            placeholder="全部行业"
            clearable
            filterable
            v-model="form.mccType"
            @change="getGroup">
            <el-option v-for="item in mcc_list" :label="item.mccTxt" :value="item.mccCode" :key="item.mccCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="mccMiddle"
          class="form-flex-item"
          :rules="{
            required: !businessEditable,
            message: '请选择行业小类',
            trigger: 'blur'
          }">
          <el-select
            style="width:200px;"
            :disabled="(passed || businessEditable || readOnly) && !isUpgrade"
            placeholder="行业小类"
            clearable
            filterable
            v-model="form.mccMiddle"
            @change="getMccDetails">
            <el-option v-for="item in mccMiddle_list" :label="item.mccTxt" :value="item.mccCode" :key="item.mccCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="mccCode"
          :rules="{
            required: !businessEditable,
            message: '请选择详细类别',
            trigger: 'blur'
          }">
          <el-select
            style="width:200px;"
            :disabled="(passed || businessEditable || readOnly) && !isUpgrade"
            placeholder="请选择详细类别"
            filterable
            clearable
            v-model="form.mccCode">
            <el-option
              v-for="item in group_list"
              :key="item.mccCode"
              :label="item.mccTxt"
              :value="item.mccCode" ></el-option>
          </el-select>
        </el-form-item>
      </el-row>
    </el-form-item>
    <el-form-item label="客服电话" prop="servicePhone">
      <el-input class="form-input" v-model="form.servicePhone" placeholder="用于联系商家客服，不填默认为商户账号信息填写手机号" :disabled="readOnly"></el-input>
    </el-form-item>
    </el-card>
    <el-card shadow="never" v-if="readOnly || isEdit">
    <h2>联系人信息&nbsp;<auth-button opt="edit_contact" @click.native="toChangeContact" label="修改" v-if="isEdit"></auth-button></h2>
    <el-divider/>
      <div class="contactDiv">
        <div class="contactItem"><span class="contactLabel">联系人姓名</span>{{form.contactName ? form.contactName : '-'}}</div>
        <div class="contactItem"><span class="contactLabel">联系人身份证</span>{{form.contactIdCard ? form.contactIdCard : '-'}}</div>
        <div class="contactItem"><span class="contactLabel">联系人手机号</span>{{form.contactPhoneNo ? form.contactPhoneNo : '-'}}</div>
      </div>
    </el-card>
    <el-dialog
      :visible.sync="dialogVisible"
      width="500px"
      title="修改联系人信息"
      @close="() => this.dialogVisible = false">
      <el-form
        label-width="120px"
        ref="contactInfo"
        label-position="left"
        :model="contactInfo"
        :rules="rule_data"
        :disabled="readOnly"
        class="contactForm">
        <el-form-item label="联系人姓名" prop="contactName">
          <el-input class="form-input" v-model="contactInfo.contactName" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系人身份证" prop="contactIdCard">
          <el-input class="form-input" v-model="contactInfo.contactIdCard" placeholder="请输入联系人身份证"></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="contactPhoneNo">
          <el-input class="form-input" v-model="contactInfo.contactPhoneNo" placeholder="请输入联系人手机号"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import ChangePhone from './changePhone'
import { checkMerchantId, checkUsername, updateContactInfo } from '@/api/merchant'
import { hidePhoneNum } from '@/utils/hideSensitiveInfo.js'
import { getMcc } from '@/api/global'
import ViewAccount from '@/components/ViewAccount'
import { agentMixins } from './agentMixins'
export default {
  components: {
    ChangePhone,
    ViewAccount
  },
  mixins: [agentMixins],
  data () {
    return {
      headShopMerchantIdError: '', // 总店编号错误信息
      userNameItemError: '', // 登录账号错误信息
      checkLoading: false, // 登录账号校验加载
      mcc_list: [], // 行业大类列表
      mccMiddle_list: [], // 行业小类列表
      group_list: [], // 行业详细类列表
      headShopMerchantIdOld: '',
      dialogVisible: false,
      contactInfo: {
        contactName: '',
        contactIdCard: '',
        contactPhoneNo: ''
      }
    }
  },
  mounted () {
    this.getMcc(1, 0)// 获取行业类型
    console.log('isChain: ', this.isChain)
  },
  watch: {
    needMcc (val) {
      if (val) {
        this.resetMccGroup()
      }
    }
  },
  computed: {
    headShopMerchantIdInput () {
      return !(this.form.shopType === 1)
    },
    fAgentId () { return this.$store.getters.userId },
    ifHide () { return this.form.statusDesc === '审核通过' || this.form.statusDesc === '待审核' },
    businessEditable () { return this.form.businessInfoFlag === 1 }
  },
  methods: {
    /**
             * @description 选中行业大类后获取行业小类列表
             * @param {Number} id 选中的大类id
             */
    getGroup (id) {
      if (id) {
        this.getMcc(2, id)
        this.form.mccMiddle = ''
        this.form.mccCode = ''
      }
    },
    /**
             * @description 选中行业小类后获取行业详细类别列表
             * @param {Number} id 选中的小类id
             */
    getMccDetails (id) {
      if (id) {
        this.getMcc(3, id)
        this.form.mccCode = ''
      }
    },
    /**
             * @description 行业大类和小类的列表获取
             */
    getMcc (level, id) {
      let params = {
        level: level
      }
      let listKey = ''
      if (level === 3 && id !== 0) {
        params.fatherCode = id
        this.form.mccCode = ''
        listKey = 'group_list'
      } else if (level === 2 && id !== 0) {
        params.fatherCode = id
        this.form.mccMiddle = ''
        listKey = 'mccMiddle_list'
      } else {
        listKey = 'mcc_list'
      }
      this[listKey] = []
      params = qs.stringify(params)
      getMcc(params).then(data => {
        if (data.result_cde === '0') {
          this[listKey] = data.data
        }
      })
    },
    /**
         * @description 加载本地数据之后获取行业列表
         */
    resetMccGroup () {
      const mccMiddle = this.form.mccMiddle
      const mccCode = this.form.mccCode
      this.getGroup(this.form.mccType)
      this.form.mccMiddle = mccMiddle
      this.getMccDetails(this.form.mccMiddle)
      this.form.mccCode = mccCode
    },
    /**
     * @description 检测账号的可用性
     */
    checkUserName () {
      let userName = this.form.username
      if (userName === '') {
        this.$message({
          message: '请输入登录账号.'
        })
        return false
      }
      userName = qs.stringify({ userName: userName })
      this.checkLoading = true
      this.userNameItemError = ''
      checkUsername(userName).then(data => {
        this.checkLoading = false
        if (data.error_code === '0') {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
        } else {
          this.userNameItemError = data.error_msg
          this.$message({
            message: data.error_msg,
            type: 'warning'
          })
        }
      })
    },
    getNewMobile (value) {
      this.form.mobile = this.ifHide ? hidePhoneNum(value) : value || ''
    },
    handleViewAccount (account) {
      this.form.username = account.fUserName
      this.form.mobile = account.fMobile
      this.businessForm.legalName = account.fApplicant
      this.form.servicePhone = account.fServicePhone
      this.settleForm.holder = account.fBankHolder
      this.settleForm.bankCardNo = account.fBankAccount
    },
    /**
     * @description 切换店铺类型
     * @param {Number} value 0分店，1总店
     */
    changeShopType (value) {
      // 总店，清空内容
      if (value === 1) {
        this.form.headMerchantId = ''
        this.settleForm.settleTo = ''
        this.form.merchantType = ''
        this.form.realMerchantType = ''
        this.form.merchantShortName = ''
        this.form.mccCode = ''
        this.form.mccMiddle = ''
        this.form.mccType = ''
        this.form.businessInfoFlag = ''
        this.businessInfoMethod(0)
        this.$parent.$parent.$refs.settleForm.resetFields()
        this.$parent.$parent.$refs.settleInfo.$refs.bankBranchForm.$refs.form.clearValidate()
        this.$parent.$parent.$refs.basicForm.clearValidate()
      }
    },
    /**
     * @description 总商户编号输入框获取焦点事件
     */
    handleHeadShopMerchantIdBlur () {
      const data = qs.stringify({ FMerchantId: this.form.headMerchantId })
      this.headShopMerchantIdError = ''
      // 查询总店编号是否有误
      checkMerchantId(data).then(response => {
        // 如果总店编号存在
        if (response.error_code === '0') {
          this.$message({
            message: response.error_msg,
            type: 'success'
          })
          // 如果总店商户id修改过，重置商户入网信息
          if (this.headShopMerchantIdOld !== this.form.headMerchantId) {
            // 如果企业资料选的是总店，先清空内容
            if (this.form.businessInfoFlag === 1) {
              this.businessInfoMethod(0)
            }
            // 如果结算对象是总店且是进件加盟分店，清空内容
            if (this.settleForm.settleTo === 1 && this.headShopMerchantIdInput) {
              this.settleForm.settleTo = ''
              this.settleToMethod(this.settleForm.settleTo)
            }
            //    查询总店的数据，如果企业资料和结算信息选择总店就可以直接回填
            this.getParentData()
          }
        } else {
          this.headShopMerchantIdError = response.error_msg
          this.$message({
            message: response.error_msg,
            type: 'warning'
          })
        }
        // 保存原来的总店商户id
        this.headShopMerchantIdOld = this.form.headMerchantId
      })
    },
    wxMchTypeChange (value) {
      if (value > 2 && this.form.merchantType === 3) {
        this.form.merchantType = 3
        this.form.companyChildType = value - 2
        return
      }
      if (value === 1) {
        this.businessForm.licenseFlag = true
        this.resetLicense()
        this.businessForm.credentialType = 1
        this.settleForm.accountType = 1
        this.settleForm.legalFlag = 1
        this.settleForm.holder = this.businessForm.legalName
        this.settleForm.bankIdCardType = this.businessForm.credentialType
        this.settleForm.accountIdCardNo = this.businessForm.idCardNo
        this.form.merchantType = 1
        this.form.companyChildType = ''
      } else {
        this.businessForm.licenseFlag = false
        this.settleForm.accountType = ''
        this.settleForm.legalFlag = ''
        this.businessForm.merchantName = ''
        if (value >= 3) {
          this.form.merchantType = 3
          this.form.companyChildType = value - 2
        } else {
          this.form.merchantType = 2
        }
      }
    },
    changeBusinessInfo (value) {
      this.businessInfoMethod(value)
      if (value === 1) {
        this.resetMccGroup()
      }
    },
    toChangeContact () {
      this.contactInfo.contactName = this.form.contactName
      this.contactInfo.contactIdCard = this.form.contactIdCard
      this.contactInfo.contactPhoneNo = this.form.contactPhoneNo
      this.dialogVisible = true
    },
    editContact () {
      const params = qs.stringify(this.contactInfo)
      this.$refs.contactInfo.validate(valid => {
        if (valid) {
          updateContactInfo(params).then(response => {
            if (response.error_code === '0') {
              this.dialogVisible = false
              this.form.contactName = this.contactInfo.contactName
              this.form.contactIdCard = this.contactInfo.contactIdCard
              this.form.contactPhoneNo = this.contactInfo.contactPhoneNo
            } else {
              this.$message({
                type: 'error',
                showClose: true,
                message: response.error_msg
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
  .red label{
    color: red;
  }
  .form-input {
    width: 450px;
  }
  .contactForm .form-input {
    width: 300px;
  }
  .form-flex-item {
    margin-right: 5px;
  }
  .form-tip-label {
    margin: 0;
    color:#D49B5F;
    vertical-align:middle;
    display:inline-block;
    font-size:14px;
    font-family:Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  }
  .file-download-button {
    color: #409eff;
    margin: 0 10px;
  }
  .report-config-id-tip-view {
    margin: 10px 100px;
    color: #606266;
    font-size: 14px;
  }
  @mixin flex-horizontal {
    display: -webkit-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .is-participate-view {
    @include flex-horizontal;
    margin-bottom: 10px;
    .is-participate-view-title {
      margin-right: 30px;
    }
  }
  .report-config-id-tip-view {
    margin: 10px 100px;
    color: #606266;
    font-size: 14px;
  }
  .merchant-info-head-view {
    @include flex-horizontal;
    justify-content: space-between;
    .merchant-info-title-view {
      flex: 1;
    }
    .merchant-info-batch-import-view {
      .merchant-info-batch-import-buttons {
        @include flex-horizontal;
      }
      .new-file-tip {
        font-size: 14px;
        margin: 5px 0;
      }
      .new-file-name {
        font-size: 14px;
      }
    }
  }
  .submitBtn{
      display: block;
      margin: 20px auto;
  }
  p.form-tip-label{
    display: block;
  }
  .contactItem:last-child {
    margin-bottom: 0;
  }
  .contactItem {
    font-size: 14px;
    color: #606266;
    line-height: 40px;
  }
  .contactLabel {
    width: 120px;
    display: inline-block;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
</style>
